import { default as BrandDefenseFilledSmall } from '../assets/brand-defense-filled-small.svg?react';
import { default as CategoryReviewFilledSmall } from '../assets/category-review-filled-small.svg?react';
import { default as WhosMyGuestFilledSmall } from '../assets/whos-my-guest-filled-small.svg?react';
import { default as WhosMyShopperFilledSmall } from '../assets/whos-my-shopper-filled-small.svg?react';
import { default as BrandSellInFilledSmall } from '../assets/brand-sell-in-filled-small.svg?react';
import { default as DiagnosingGrowthFilledSmall } from '../assets/diagnosing-growth-filled-small.svg?react';
import { default as IncrementalityFilledSmall } from '../assets/incrementality-filled-small.svg?react';

/**
 * gets narrative icon based on route, matching the tile icons on the landing page.
 * @param  {string} narrativeRoute e.g. `/dashboard/narrative/who-is-my-guest`
 * @return {Node}   react component
 */
export const getNarrativeIcon = (narrativeRoute) => {
  const baseRoutePath = '/dashboard/narrative';

  // Restaurant narratives reuse the CPG icons for shared flows, so normalize the
  // route to its base narrative id (e.g. `.../brand-defense-restaurant` -> `brand-defense`).
  const narrativeId =
    typeof narrativeRoute === 'string'
      ? narrativeRoute.replace(`${baseRoutePath}/`, '').replace(/-restaurant$/, '')
      : '';

  switch (narrativeId) {
    case 'brand-defense':
      return <BrandDefenseFilledSmall />;
    case 'brand-sell-in':
    case 'cpg-development':
      return <BrandSellInFilledSmall />;
    case 'category-review':
      return <CategoryReviewFilledSmall />;
    case 'diagnosing-growth':
      return <DiagnosingGrowthFilledSmall />;
    case 'incrementality':
      return <IncrementalityFilledSmall />;
    case 'who-is-my-guest':
      return <WhosMyGuestFilledSmall />;
    case 'who-is-my-shopper':
      return <WhosMyShopperFilledSmall />;
    default:
      return '';
  }
};
